import { useRef, useState, useEffect } from 'react';
import anime from 'animejs/lib/anime.es.js';
import './Logo.css';
const Logo = () => {
   const creativeRef = useRef(null);
   useEffect(() => {
      creativeRef.current = anime({
         targets: '.s0',
         strokeDashoffset: [anime.setDashoffset, 0],
         strokeDashoffset: [anime.setDashoffset, 0],
         duration: 1500,
         direction: 'alternate',
         easing: 'easeInOutSine',
         delay: function (el, i) {
            return i * 500;
         },
      });

      creativeRef.current = anime.timeline({ delay: 1800 }).add({
         targets: '.s0',
         fill: '#fff',
      });
   }, []);
   return (
      <div>
         <svg
            version='1.2'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 1238 732'
            width='200'
            height='118'
            style={{
               fill: 'none',
               stroke: 'white',
               strokeWidth: '7',
               transform: 'scale(7vw)',
               maxHeight: '60%',
               maxWidth: '60%',
            }}
         >
            <path
               id='Layer'
               className='s0'
               d='m698.7 472.5c-19 68.9-90.2 220.1-180.4 220.1c-19 0-34.1-6.4-45.2-19.8c-18.2-23-22.9-63.4-12.6-113.2c14.2-75.2 49-159.1 79.9-234.3l2.4-4.8c39.6-92.6 66.5-159.9 48.3-178.1l-0.8-0.8h-2.4c-13.4 0-29.3 5.6-46.7 18.3c-68.1 51.4-151.2 205-177.3 328.4c-0.8 8-1.6 13.5-2.4 19l-0.8 3.2c-2.3 11.9-4.7 20.6-7.9 28.5c-3.9 8.7-9.5 15-16.6 18.2c-7.9 4.8-18.2 5.5-33.2 1.6c-30.9-9.5-33.3-32.5-26.2-64.9c19.8-98.2 59.4-206.6 91.9-293.7l1.5-3.9c30.9-81.6 51.5-139.3 47.5-153.6l-0.8-3.2h-3.1c-83.1 6.4-201.1 278.7-226.4 346.7c-15 64.1-38 141.7-67.3 231.2c-7.1 19-29.3 21.3-46.7 20.5c-20.6-2.3-28.5-11.8-30.9-15c-3.1-5.5-5.5-13.5-3.1-19.8c4.7-13.4 9.5-28.5 15-45.1l0.8-2.4c36.4-110 98.2-295.2 63.3-345.9c-6.3-8.7-14.2-11.9-25.3-11.9c-29.3 0-47.5 29.3-50.7 45.2c-0.8 4.7-4.7 12.6-15 12.6c-4.8 0-7.9-1.6-8.7-5.5c-0.8-3.2-0.8-6.3-0.8-6.3c4-19.8 16.6-38.8 34-51.5c20.6-15.8 48.3-22.2 76-18.2c50.7 7.1 76 37.2 77.6 91v17.4l7.1-15.8c42.8-93.4 125.1-250.1 204.2-251.7c7.2 0 13.5 0 19 1.6c19 2.4 33.3 10.3 42 23.7c13.4 19.8 14.2 50.7 3.2 91.8c-6.4 23.8-14.3 48.3-23 72.9l-9.5 26.1l16.6-22.2c42.8-59.3 87.1-91.8 124.3-91.8c22.9 0 41.9 7.9 53.8 23.8c17.4 21.3 23 56.2 15.1 100.5c-7.2 38.8-30.1 93.4-53.9 152l-3.9 11c-45.9 106.9-85.5 207.4-73.6 260.5l0.8 3.9l3.9-0.8c59.4-9.5 123.5-122.7 144.1-197.9c0-0.8 2.3-7.9 6.3-12.6c4-1.6 6.3-3.2 11.1-2.4c2.4 0 4.7 1.6 6.3 3.2c2.4 5.5 0 12.6-0.8 14.2z'
            />
            <path
               id='Layer'
               className='s0'
               d='m1200.2 470.1c-45.9 129.9-102.9 204.3-156.8 204.3c-26.1 0-45.1-8-57.7-22.2c-18.2-21.4-23-57.8-15.9-108.5c12.7-75.1 50.7-182.8 80.8-269.1c41.1-113.2 64.1-186.8 55.4-204.2l-2.4-2.4h-2.4c-151.1 0-283.3 390.3-317.4 527.2c-3.1 10.3-11.1 23.7-45.9 21.4c-13.4-0.8-23.7-5.6-30.1-12.7c-6.3-8.7-5.5-17.4-4.7-19.8c3.2-23.7 13.4-64.1 32.4-125.8c29.3-105.3 66.5-236.7 41.2-272.3q-5.9-9.5-19-9.5c-15 0-29.3 5.5-41.2 15.8c-11.8 11.1-18.9 23.8-19.7 36.4c0 1.6-1.6 8.7-6.4 11.9c-3.1 2.4-6.3 3.9-10.3 3.9c-1.5-0.7-3.9-0.7-5.5-3.1c-1.6-2.4-2.4-5.6-2.4-11.1c1.6-17.4 12.7-37.2 29.3-52.2c18.2-16.7 40.4-26.2 61-26.2c38.7-1.5 66.4 8 83.1 29.3c16.6 19.8 22.9 47.5 20.5 85.5l-0.7 19.8l8.7-18.2c50.6-102.1 132.1-224.8 230.3-224.8c24.5 0 43.5 7.9 55.4 23.7c15.8 19 20.6 51.5 12.7 95c-11.1 49.9-34.8 118-60.2 190l-0.8 4c-46.7 132.1-95 268.3-52.2 291.2l1.6 0.8l1.5-0.8c21.4-7.1 65-39.5 114.8-181.2c0 0 2.4-7.9 7.9-11.1c3.2-2.4 7.2-2.4 10.3-1.6c2.4 0 4.8 1.6 5.6 4c2.3 4.7 0 11.1-0.8 12.6z'
            />
         </svg>
      </div>
   );
};

export default Logo;
